









































































































import VueOptions from '@utils/VueOptions'
import WizardNavbar from '@ui/AudienceCreativeWizard/WizardNavbar'
import WizardNavigation from '@ui/AudienceCreativeWizard/WizardNavigation'

settings =
  name: 'InventoryCreateStep'

  resources:
    audience_creative:
      resourceName: 'audience_creative'
      slug: 'suppliers/:wizard.supplierId/audience_creatives/:audienceCreativeId/edit'
      fetch: false
    new_space:
      resourceName: 'space'
      slug: 'suppliers/:wizard.supplierId/audience_creatives/:audienceCreativeId/spaces/new'

  vue:
    props: ['wizard', 'step']

    components: {
      WizardNavbar,
      WizardNavigation,
    }

    data: ->
      newSegment: null

    computed:
      space: ->
        @prime?.new_space

    methods:
      hiSelectProductSamplingSpace: ->
        @space.type = 'product_sampling'
        @space.segment = 'Product Placement'
        @space.size = null
        @space.price_in_cents = null
        @scrollToTutorial()

      hiSelectOnsiteSpace: ->
        @space.type = 'onsite_space'
        @space.segment = 'Onsite'
        @space.size = '10x10'
        @space.price_in_cents = 50000
        @scrollToTutorial()

      hiSelectOmnichannelSpace: ->
        @space.type = 'omnichannel'
        @space.segment = 'Social & Digital'
        @space.size = null
        @space.price_in_cents = null
        @space.images = ['https://marketplace-live-assets.s3.us-west-1.amazonaws.com/spaces/online-community.png']
        @scrollToTutorial()

      hiSave: ->
        { type, segment, size, price_in_cents, images } = @space
        payload = { space: { type, segment, size, price_in_cents, images } }
        @triggerResource 'new_space', 'create_space', payload

      scrollToTutorial: ->
        setTimeout(() =>
          @scrollContainerTo '#dashboard', '.tutorial-section'
        , 100)

      onNewSpaceCreateSpace: (data, space) ->
        switch space.type
          when 'product_sampling'
            { availability_ids } = @wizard.audienceCreativeData
            @newSegment = space.id
            @bindSpacesToCreative [space], availability_ids
          when 'onsite_space'
            { availability_ids } = @wizard.audienceCreativeData
            @newSegment = space.segment
            @bindSpacesToCreative [space], availability_ids
          when 'omnichannel'
            @navToSpaceEditPage space.type, space.id

      bindSpacesToCreative: (spaces, availabilityIds) ->
        @wizard.showWaitingModal()
        for chunk in @chunkArray(availabilityIds, 500)
          payload =
            space_ids: spaces.map((s) => s.id)
            availability_ids: chunk
          @triggerResource 'audience_creative', 'bind_spaces', payload
      onAudienceCreativeBindSpaces: (data, response) ->
        @wizard.fetchAudienceCreative()
        @navToSpaceEditPage @space.type, @newSegment

      navToSpaceEditPage: (type, spaceId) ->
        switch type
          when 'product_sampling'
            @wizard.navToStepName 'sampling-space-edit'
            @$router.replace { query: { ...@$route.query, spaceId } }
          when 'onsite_space'
            @wizard.navToStepName 'onsite-space-edit'
            @$router.replace { query: { ...@$route.query, spaceId } }
          when 'omnichannel'
            @wizard.navToStepName 'omnichannel-space-edit'
            @$router.replace { query: { ...@$route.query, spaceId } }

export default VueOptions.vue settings
